import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=09235dd0&"
import script from "./homepage.ts?vue&type=script&lang=ts&"
export * from "./homepage.ts?vue&type=script&lang=ts&"
import style0 from "./homepage.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports